import React, { useRef, useCallback } from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Video from "core/components/Video";
import Box from "@mui/material/Box";

const PREFIX = "BackgroundVideo";

const classes = {
  video: `${PREFIX}-video`,
};

const Root = styled(Box)({
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  zIndex: -1,
  position: "absolute",
  opacity: 0,
  transition: "opacity 1s ease",
});

const StyledContainer = styled(Box)(({ theme, background }) => {
  const style = {
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    position: "absolute",

    [`& .${classes.video}`]: {
      width: "100%",
      height: "100%",
      position: "absolute",
      objectFit: "cover",
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
    },
  };

  if (background) {
    if ("brightness" in background) {
      if (theme.palette.mode === "dark") {
        style["filter"] = `brightness(${background?.brightness})`;
      } else {
        style["filter"] = `opacity(${background?.brightness})`;
      }
    }
  }

  return style;
});

export default function BackgroundVideo({ background, backgroundVideo }) {
  const rootRef = useRef(null);

  const onCanPlay = useCallback(() => {
    if (rootRef.current) {
      rootRef.current.style.opacity = 1;
    }
  }, []);

  if (!backgroundVideo) return null;

  if (!backgroundVideo.playlistUrl) {
    return (
      <Root ref={rootRef}>
        <StyledContainer background={background}>
          <video
            className={classes.video}
            src={backgroundVideo.url}
            onCanPlay={onCanPlay}
            muted
            autoPlay
            playsInline
            loop
          />
        </StyledContainer>
      </Root>
    );
  }

  return (
    <Root ref={rootRef}>
      <StyledContainer background={background}>
        <Video
          hlsUrl={backgroundVideo.playlistUrl}
          autoPlay
          muted
          loop
          playsInline
          onCanPlay={onCanPlay}
          videoElementId={backgroundVideo.id}
          className={classes.video}
          maxBufferLength={10}
        >
          {(videoElement) => {
            return videoElement;
          }}
        </Video>
      </StyledContainer>
    </Root>
  );
}

BackgroundVideo.propTypes = {
  background: PropTypes.shape({
    brightness: PropTypes.number,
  }),
  backgroundVideo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    playlistUrl: PropTypes.string,
  }),
};
